// =============================================================================
// FILE:
// frontend/src/modules/pms/task_execution/services/taskExecutionService.js
// =============================================================================

import axiosClient
from "../../../../api/axiosClient";


// =============================================================================
// GET MY TASKS WORKBENCH
// =============================================================================

export async function getMyTasksWorkbench(

  filters = {}

) {

  const response =
    await axiosClient.get(

      "/api/pms/task-execution/my-workbench",

      {
        params: filters
      }
    );

  return response.data;
}


// =============================================================================
// GET TASK EXECUTION DETAILS
// =============================================================================

export async function getTaskExecutionDetails(

  taskId

) {

  const response =
    await axiosClient.get(

      "/api/pms/task-execution/my-workbench"
    );

  return response.data;
}


// =============================================================================
// GET TASK MATERIALS
// =============================================================================

export async function getTaskMaterials(

  taskId

) {

  const response =
    await axiosClient.get(

      `/api/pms/task-execution/${taskId}/materials`
    );

  return response.data;
}


// =============================================================================
// GET TASK REQUESTS
// =============================================================================

export async function getTaskRequests(

  taskId

) {

  const response =
    await axiosClient.get(

      `/api/pms/task-execution/${taskId}/requests`
    );

  return response.data;
}


// =============================================================================
// GET TASK ISSUES
// =============================================================================

export async function getTaskIssues(

  taskId

) {

  const response =
    await axiosClient.get(

      `/api/pms/task-execution/${taskId}/issues`
    );

  return response.data;
}


// =============================================================================
// GET TASK TIMELINE
// =============================================================================

export async function getTaskTimeline(

  taskId

) {

  const response =
    await axiosClient.get(

      `/api/pms/task-execution/${taskId}/timeline`
    );

  return response.data;
}


// =============================================================================
// START TASK EXECUTION
// =============================================================================

export async function startTaskExecution(

  taskId,

  payload = {}

) {

  const response =
    await axiosClient.post(

      `/api/pms/task-execution/${taskId}/start`,

      payload
    );

  return response.data;
}


// =============================================================================
// HOLD TASK EXECUTION
// =============================================================================

export async function holdTaskExecution(

  taskId,

  payload = {}

) {

  const response =
    await axiosClient.post(

      `/api/pms/task-execution/${taskId}/hold`,

      payload
    );

  return response.data;
}


// =============================================================================
// COMPLETE TASK EXECUTION
// =============================================================================

export async function completeTaskExecution(

  taskId,

  payload = {}

) {

  const response =
    await axiosClient.post(

      `/api/pms/task-execution/${taskId}/complete`,

      payload
    );

  return response.data;
}


// =============================================================================
// SAVE EXECUTION NOTES
// =============================================================================

export async function saveExecutionNotes(

  taskId,

  payload = {}

) {

  const response =
    await axiosClient.post(

      `/api/pms/task-execution/${taskId}/notes`,

      payload
    );

  return response.data;
}
// =============================================================================
// CREATE EXECUTION UPDATE
// =============================================================================
export const createExecutionUpdate = async (payload) => {

    const response = await axiosClient.post(

        "/api/pms/task-execution-update/create",

        payload
    );

    return response.data;
};


// =============================================================================
// GET EXECUTION HISTORY
// =============================================================================
export const getExecutionHistory = async (taskId) => {

    const response = await axiosClient.get(

        `/api/pms/task-execution-update/task/${taskId}/history`
    );

    return response.data;
};


// =============================================================================
// GET LATEST EXECUTION STATUS
// =============================================================================
export const getLatestExecutionStatus = async (taskId) => {

    const response = await axiosClient.get(

        `/api/pms/task-execution-update/task/${taskId}/latest-status`
    );

    return response.data;
};

export const getMaterialConsumptionSummary =
  async (taskId) => {

    const response =
      await axiosClient.get(

        `/api/pms/task-execution-update/material-consumption-summary/${taskId}`
      );

    return response.data;
};

// =============================================================================
// SAVE MATERIAL CONSUMPTION
// =============================================================================
export const saveMaterialConsumption =
  async (payload) => {

    const response =
      await axiosClient.post(

        "/api/pms/task-execution-update/save-material-consumption",

        payload
      );

    return response.data;
};